var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"color":"white","slider-color":_vm.$store.state.theme.brand_color},model:{value:(_vm.currentView),callback:function ($$v) {_vm.currentView=$$v},expression:"currentView"}},[_c('v-tab',{attrs:{"href":"#holiday","ripple":""}},[_vm._v("Holiday")])],1),_vm._v(" "),_c(_vm.currentView,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827ae784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/generali/main.vue
// module id = null
// module chunks = 